// Implements: F-IDN-027
/** A person as the v3 tables show one: avatar, name and e-mail. */

import type { ReactElement } from "react";

import { Avatar } from "../../../shared/ui/atoms/Avatar";
import type { UserSummary } from "../../../types/api";
import styles from "./Organization.module.css";

export function PersonCell({ user }: { readonly user: UserSummary }): ReactElement {
  return (
    <div className={styles.person}>
      <Avatar name={user.full_name} />
      <div className={styles.personText}>
        <span className={styles.strong}>{user.full_name}</span>
        <span className={styles.meta}>{user.email}</span>
      </div>
    </div>
  );
}
